module.exports = __webpack_public_path__ + "img/image_30.a97e4ec2.png";